//js start of search bar in blog page


$(document).ready(function(){
  $("#myInput").on("keyup", function() {
    var value = $(this).val().toLowerCase();
    if(value != ''){
      $('.search_result').css("display", "block");
      $("#search_result ul li").filter(function() {
       $(this).toggle($(this).text().toLowerCase().indexOf(value) > -1)
      });
    }else{
      $('.search_result').css("display", "none");
    } 
  }); 

   // Show the clear button when text is entered
    $('#myInput').on('input', function() {
        if ($(this).val().length > 0) {
            $('.clearText').css("display", "block");
        } else {
            $('.clearText').css("display", "none");
          }
    });
    
    // Clear the text input when the clear button is clicked
    $('.clearText').click(function() {
        $('#myInput').val('');
        $(this).css("display", "none");
        $('.search_result').css("display", "none");
    });
});
//js start of search bar in blog page 

//js start of search bar in blog page

// $(document).ready(function(){
//   $("#myInput").on("keyup", function() {
//     var value = $(this).val().toLowerCase();
//     if(value != ''){
//       $('.search_result').css("display", "block");
//       $("#search_result ul li").filter(function() {
//        $(this).toggle($(this).text().toLowerCase().indexOf(value) > -1)
//       });
//     }else{
//       $('.search_result').css("display", "none");
//     } 
//   }); 
// });
//js start of search bar in blog page

// mega menu display on hover js start
$(document).ready(function(){
  $(function() {
  $('.header .header__inline-menu details').on('mouseover', function() {
    $(this).attr('open', true);
  }).on('mouseout', function() {
    $(this).attr('open', false);
  });
});
});

// mega menu display on hover js end



// load More Js 

// function startLoading() {
//     $('body').addClass('loading-products');
// }

// function stopLoading() {
//     $('body').removeClass('loading-products');
// }

// function highlightClickedProduct(scrollToProduct = false) {
//     var storedProductId = localStorage.getItem('clickedProductId');
//     if (storedProductId) {
//         $('.grid__item .card-wrapper').css('background-color', '');
//         var $highlightedProduct = $('#' + storedProductId);
//         if ($highlightedProduct.length) {
//             if (scrollToProduct) {
//                 $('html, body').animate({
//                     scrollTop: $highlightedProduct.offset().top
//                 }, 1000, function() {
//                     localStorage.removeItem('clickedProductId');
//                     localStorage.removeItem('currentPage');
//                     localStorage.removeItem('loadedProductsCount');
//                 });
//             }
//         }
//     }
// }

// function initializeLoadMore() {
//     $('.js-load-more').off('click').on('click', function() {
//         var $this = $(this),
//             totalPages = parseInt($('[data-all-pages]').val()),
//             currentPage = parseInt($('[data-this-page]').val()),
//             datacollurl = $('[data-coll-url]').val();

//         startLoading();
//         $this.attr('disabled', true);
//         $this.find('[load-more-text]').addClass('hide');
//         $this.find('[loader]').removeClass('hide');

//         var nextUrl = $('[data-next-link]').val();
//         var current_page_new = currentPage + 1;
//         var next_coll = currentPage + 2;

//         localStorage.setItem('currentPage', current_page_new);

//         $.ajax({
//             url: nextUrl,
//             type: 'GET',
//             dataType: 'html',
//             success: function(responseHTML) {
//                 $('[data-next-link]').val(datacollurl + "?page=" + next_coll);
//                 $('[data-this-page]').val(current_page_new);
//                 $('#product-grid').append($(responseHTML).find('#product-grid').html());

//                 var currentProductsCount = parseInt(localStorage.getItem('loadedProductsCount') || '0');
//                 localStorage.setItem('loadedProductsCount', currentProductsCount + $(responseHTML).find('#product-grid').children().length);

//                 highlightClickedProduct(false);
//             },
//             complete: function() {
//                 if (current_page_new < totalPages) {
//                     $this.attr('disabled', false);
//                     $this.find('[load-more-text]').removeClass('hide');
//                     $this.find('[loader]').addClass('hide');
//                 }
//                 if (current_page_new >= totalPages) {
//                     $this.find('[load-more-text]').text('Products Finished').removeClass('hide');
//                     $this.find('[loader]').addClass('hide');
//                     // Scroll to the clicked product after all products are loaded
//                     highlightClickedProduct(true);
//                 }
//                 stopLoading();
//             }
//         });
//     });
// }

// function loadPreviouslyLoadedProducts(page, storedPage, totalPages, $loadMoreButton) {
//     if (page <= storedPage && page <= totalPages) {
//         var nextUrl = $('[data-next-link]').val();
//         $.ajax({
//             url: nextUrl,
//             type: 'GET',
//             dataType: 'html',
//             success: function(responseHTML) {
//                 $('#product-grid').append($(responseHTML).find('#product-grid').html());

//                 var loadedProductsCount = parseInt(localStorage.getItem('loadedProductsCount') || '0');
//                 localStorage.setItem('loadedProductsCount', loadedProductsCount + $(responseHTML).find('#product-grid').children().length);

//                 $('[data-this-page]').val(page);
//                 var next_coll = page + 1;
//                 $('[data-next-link]').val($('[data-coll-url]').val() + "?page=" + next_coll);
//             },
//             complete: function() {
//                 if (page === storedPage || page >= totalPages) {
//                     // Scroll to the clicked product once all previously loaded products are loaded
//                     highlightClickedProduct(true);
//                 }
//                 loadPreviouslyLoadedProducts(page + 1, storedPage, totalPages, $loadMoreButton);
//             }
//         });
//     } else {
//         $loadMoreButton.attr('disabled', false);
//         if (page > totalPages) {
//             $loadMoreButton.find('[load-more-text]').text('Products Finished').removeClass('hide');
//         }
//         stopLoading();
//     }
// }

// $(document).ready(function() {
//     // Check if `clickedProductId` is set; if not, clear relevant localStorage items
//     if (!localStorage.getItem('clickedProductId')) {
//         localStorage.removeItem('currentPage');
//         localStorage.removeItem('loadedProductsCount');
//     }

//     initializeLoadMore();

//     var storedPage = parseInt(localStorage.getItem('currentPage') || '1');
//     var totalPages = parseInt($('[data-all-pages]').val());

//     if (storedPage > 1) {
//         startLoading(); 
//         var $loadMoreButton = $('.js-load-more');
//         $loadMoreButton.attr('disabled', true);
//         loadPreviouslyLoadedProducts(2, storedPage, totalPages, $loadMoreButton);
//     }
// });

// $(document).on('change', 'select#SortBy', function() {
//     setTimeout(function() {
//         localStorage.removeItem('currentPage');
//         localStorage.removeItem('loadedProductsCount');
//         localStorage.removeItem('clickedProductId');

//         initializeLoadMore();
//     }, 1500);
// });

// $(document).on('change', '.mobile-facets__item', function(e) {
//     if ($(this).find("input").is(":checked")) {
//         setTimeout(function() {
//             localStorage.removeItem('currentPage');
//             localStorage.removeItem('loadedProductsCount');
//             localStorage.removeItem('clickedProductId');
//             initializeLoadMore();
//         }, 1500);
//     }
// });

// $(document).on('click', '.grid__item .card-wrapper', function() {
//     var productId = $(this).attr('id');
//     if (productId) {
//         localStorage.setItem('clickedProductId', productId);
//     }
// });

// Load More Js End 



// js start for cardproduct color vaiant
$(document).ready(function(){
  $(document).on('click','.collection-swatch',function() {
    let swatchDataSrc =  $(this).attr('swatch-data-src');
     $(this).parents('.card-wrapper').find('.card_product_image').attr('src', swatchDataSrc);
    $(this).parents('.card-wrapper').find('.card_product_image').attr('srcset' , swatchDataSrc);
    // alert(swatchDataValue);
  });
});
// js end for cardproduct color vaiant